import React, { useState, useContext, useEffect, useRef } from "react";
import { Modal } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { LanguageContext } from "../contexts/LanguageContext";
import Cookies from 'js-cookie';
import { GetPayLoad } from "../services/PayLoadStorage";
import { getApiService } from "../services/ApiService";
import {Spinner, Form} from 'react-bootstrap';
import DateRangePickerr from "../components/dateRangePickerr.jsx";
import { toast } from "react-toastify";

const Paymentauth = ({ billingContent, genericContent}) => {
    const navigate = useNavigate();
    const Payload = GetPayLoad("PayLoad");
    const [paymentAuthorizations, setpaymentAuthorizations] = useState([]);
    const [paymentAuthErrorFlag, setPaymentAuthErrorFlag] = useState(false);
    const [allPaymentAuth, setAllPaymentAuth] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [downloadFormat, setDownloadFormat] = useState("pdf");
    const [apiCallsCompleted, setApiCallsCompleted] = useState(false);
    const ref = useRef(null); // Ref for the <main> tag
    const [isContentReady, setContentReady] = useState(false);
    
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const headers = {
        "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
        "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
        "X-Hps-Region": Payload?.region,
        "X-Hps-Carrier": Payload?.owning_carrier,
    };
    
    // Fetch Billing History Data
    useEffect(() => {
      const targetUrl = process.env.REACT_APP_API_PAYMENT_AUTHORIZATIONS_ENDPOINT;
      getApiService(baseUrl, targetUrl, { cim: Payload?.cim }, headers)
      .then((response) => {
        setLoading(false);      
        if (response?.data?.statusCode !== 200) {
          setPaymentAuthErrorFlag(true);
        } else {
          const result = response.data.data;
          setPaymentAuthErrorFlag(false);
          setpaymentAuthorizations(result);
          setAllPaymentAuth(result);  
          setApiCallsCompleted(true); 
        }
      }).catch((error) => {
        setLoading(false);
        setPaymentAuthErrorFlag(true);
      });
    }, []);

    const paymentAuthcolumns = [
      billingContent?.billing_payment_auth_holder_name_text,
      billingContent?.billing_payment_auth_scheduled_on_text,
      billingContent?.billing_payment_auth_scheduled_for_text,
      billingContent?.billing_payment_auth_account_type_text,
      billingContent?.billing_payment_auth_account_last_four_text,
      billingContent?.billing_payment_auth_amount_text,
      billingContent?.billing_payment_auth_payment_freq_text,
      billingContent?.billing_payment_auth_routing_no_text,
    ]; 

    // Handle Date Filter Apply
    const handleDataFromPaymentAuth = (filterType, dateRange) => {
        const { startDate, endDate } = dateRange;
        const filtered = allPaymentAuth.filter((record) => {
          const addedDate = new Date(record.addedDate);
          return addedDate >= startDate && addedDate <= endDate;
        });
        setpaymentAuthorizations(filtered);  
    };

    // Handle Payment Authorization Download PDF & Excel
    const handlePaymntAuthDownloadPDF = () => {
      if (paymentAuthorizations?.length > 0) {
        let downloadFormat = document.querySelector(
          'input[name="padownloadFormat"]:checked'
        ).value;
        const displayFlag = 1;
        const displayName = Payload?.displayName;
        const targetCaseUrl = baseUrl + process.env.REACT_APP_API_PDF_EXCEL_DOWNLOAD_ENDPOINT;
        const currentLang = Cookies.get("lang") || "eng";
  
        // Create a form element
        const form = document.createElement("form");
        form.method = "POST";
        form.action = targetCaseUrl;
        form.target = "_blank"; // Open in a new tab or window
  
        // Add form fields
        const fields = {
          cim: Payload?.cim,
          region: Payload?.region,
          case_num: Payload?.case_num,
          owningCarrier: Payload?.owning_carrier,
          downloadFormat: downloadFormat,
          language: currentLang,
          columns: JSON.stringify(paymentAuthcolumns),
          rows: JSON.stringify(paymentAuthorizations),
          sitecd: Payload?.site_cd,
          displayFlag: displayFlag,
          displayName: Payload?.displayName,
          isSTPSAvailable: Cookies.get('showSTPS') !== 'false' ? true : false,
          isSTPS2Available: Cookies.get('showSTPS2') !== 'false' ? true : false,
          /* PMO0004087 CHG0127827 SD47534 */
          isSTPS3Available: Cookies.get('showSTPS3') !== 'false' ? true : false,
          pageName: "PaymentAuthorizations",
          state: Payload?.state || null,
          "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
          "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
          "X-Hps-Region": Payload?.region,
          "X-Hps-Carrier": Payload?.owning_carrier,
        };
  
        for (const key in fields) {
          if (fields[key] !== undefined) {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = key;
            input.value = fields[key];
            form.appendChild(input);
          }
        }
  
        // Append the form to the body, submit it, and remove it
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
        if (downloadFormat === "excel") {
          const message =
            genericContent?.excel_download_sucess ||
            "Excel Downloaded Successfully";
          toast.success(message);
        }
      } else {
        const message =
          billingContent?.billing_payment_auth_nodata_text ||
          "No payment authorizations available for download.";
        toast.error(message);
      }
    };

    // Accessibility: Focus Management
    const [userInteracted, setUserInteracted] = useState(false);
      
    useEffect(() => {
      const handleUserInteraction = () => {
        setUserInteracted(true);
      };
      
      // Listen for user interactions
      document.addEventListener('click', handleUserInteraction);
      document.addEventListener('keydown', handleUserInteraction);
        
      return () => {
        document.removeEventListener('click', handleUserInteraction);
        document.removeEventListener('keydown', handleUserInteraction);
      };
    }, []);
      
    useEffect(() => {
      let timeoutId;      
      if (apiCallsCompleted && !isContentReady) {
        timeoutId = setTimeout(() => {
          setContentReady(true);          
          // Only auto-focus if user hasn't interacted
          if (!userInteracted && ref.current) {
            requestAnimationFrame(() => {
              ref.current.focus({ preventScroll: true });
            });
          }
        }, parseInt(process.env.REACT_APP_READABILITY_TIMEOUT));
      }      
      return () => {
        if (timeoutId) clearTimeout(timeoutId);
      };
    }, [apiCallsCompleted, isContentReady, userInteracted]);

    const getPaymentMethod = (cardType) => {
      switch (cardType) {
        case "CCD":
          return billingContent?.billing_payment_auth_cc_text;
        case "DBT":
          return billingContent?.billing_payment_auth_dc_text;
        default:
          return billingContent?.billing_payment_auth_cc_text;
      }
    };

    return (
        <>
        <main role="main"
          tabIndex="-1" // Make the <main> tag focusable
          ref={ref} // Attach the ref to the <main> tag
          aria-label={billingContent?.billing_payment_auth_title}
          aria-live="polite"
          style={{ outline: 'none' }} // revmove border
        >
          <Modal.Header className={`modal-header d-xl-flex d-md-flex ${Payload?.owning_carrier === 'Q5' ? 'mobile-close-btn' : ''}`} closeButton>
            <div className="d-xl-flex d-md-flex pb-3" style={{ width: "100%" }} id="payment-auth-title">
              <Modal.Title className="col-xl-3 col-md-3 mt-xl-margin ps-2">
                {Payload?.owning_carrier === 'Q5' ? (
                  <h3 tabIndex={0} className="q5-payment-auth-title">{billingContent?.billing_payment_auth_title}</h3>
                ) : (
                  <h5 tabIndex={0}>{billingContent?.billing_payment_auth_title}</h5>
                )}
              </Modal.Title>
              {!isLoading && !paymentAuthErrorFlag && paymentAuthorizations && (
                <div className="col-xl-9 col-md-9 d-flex float-sm-start billing-history-controls-wrapper">
                  <DateRangePickerr onApplyDateFilter={handleDataFromPaymentAuth} carrier={Payload?.owning_carrier} />
                  <div className="d-flex align-items-center flex-nowrap billing-history-button-group">
                  {paymentAuthorizations?.length > 0 && (
                    <div className="d-flex align-items-center ms-md-2 billing-history-radio-wrapper" role="radiogroup" aria-label="Download Format">
                      <Form.Check
                      inline
                      label="PDF"
                      name="padownloadFormat"
                      type="radio"
                      id="pa-pdf-radio"
                      value="pdf"
                      aria-label="Select PDF download format"
                      defaultChecked
                      className="payment-download-radio"
                      onChange={(e) => setDownloadFormat(e.target.value)}
                      />
                      <Form.Check
                      inline
                      label="Excel"
                      name="padownloadFormat"
                      type="radio"
                      id="pa-excel-radio"
                      value="excel"
                      aria-label="Select Excel download format"
                      className="payment-download-radio"
                      onChange={(e) => setDownloadFormat(e.target.value)}
                      />
                  </div>
                  )}
                  {paymentAuthorizations?.length > 0 && (
                    <button
                      className={`btn ${Payload?.owning_carrier === 'Q5' ? 'btn-outline-secondary' : 'btn-primary'} rounded ms-1 billing-history-download-btn`}
                      onClick={() => handlePaymntAuthDownloadPDF()}
                      aria-label={billingContent?.billing_billdetail_export_pdf_hint || "Download"}
                    >
                      {billingContent?.billing_billdetail_export_pdf_hint || "Download"}{" "}
                      {Payload?.owning_carrier !== 'Q5' && (
                        <i className="fe fe-download" aria-hidden="true"></i>
                      )}
                    </button>
                  )}
                </div>
                </div>
              )}
            </div>
          </Modal.Header>
          <Modal.Body className="billing-history-modal-body">
            <div className="" id="payment-auth-description">
              {paymentAuthErrorFlag && (
                <div className="api-error-msg">
                  {genericContent?.finance_service_error}
                </div>
              )}
              {isLoading && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                    margin: "inherit",
                  }}
                >
                  <Spinner animation="border" role="status"></Spinner>
                  <div style={{ fontSize: "12px" }}>
                    {genericContent?.loading_message}
                  </div>
                </div>
              )}
              <div className="bd-example table-responsive d-grid-tbl billing-tables mb-4">
                {!isLoading && !paymentAuthErrorFlag && paymentAuthorizations && (
                  <div className="d-flex px-2">
                    <div tabIndex={0} className="col-12 mb-2 nav-billings">
                      <h6>
                        {paymentAuthorizations && paymentAuthorizations.length}{" "}
                        {billingContent?.billing_transaction_text}
                        {paymentAuthorizations?.length > 1 ? "(s)" : ""}{" "}
                        {billingContent?.billing_found_text}
                      </h6>
                    </div>
                  </div>
                )}
                {!isLoading && !paymentAuthErrorFlag && paymentAuthorizations && (
                  <table tabIndex={0} className="table table-striped">
                    <thead>
                      <tr>
                        <th scope="col">
                          <span className="visually-hidden"> row 1 column 1 </span>
                          {billingContent?.billing_payment_auth_holder_name_text}
                        </th>
                        <th scope="col">
                          <span className="visually-hidden"> column 2 </span>
                          {billingContent?.billing_payment_auth_scheduled_on_text}
                        </th>
                        <th scope="col">
                          <span className="visually-hidden"> column 3 </span>
                          {billingContent?.billing_payment_auth_scheduled_for_text}
                        </th>
                        <th scope="col">
                          <span className="visually-hidden"> column 4 </span>
                          {billingContent?.billing_payment_auth_account_type_text}
                        </th>
                        <th scope="col">
                          <span className="visually-hidden"> column 5 </span>
                          {
                            billingContent?.billing_payment_auth_account_last_four_text
                          }
                        </th>
                        <th scope="col">
                          <span className="visually-hidden"> column 6 </span>
                          {billingContent?.billing_payment_auth_amount_text}
                        </th>
                        <th scope="col">
                          <span className="visually-hidden"> column 7 </span>
                          {billingContent?.billing_payment_auth_payment_freq_text}
                        </th>
                        <th scope="col">
                          <span className="visually-hidden"> column 8 </span>
                          {billingContent?.billing_payment_auth_routing_no_text}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {paymentAuthorizations?.length === 0 ? (
                        <tr>
                          <td colSpan={8}>
                            {" "}
                            {
                              billingContent?.billing_payment_auth_nodata_text
                            }{" "}
                          </td>
                        </tr>
                      ) : (
                        paymentAuthorizations &&
                        paymentAuthorizations.map((item, index) => (
                          <tr key={index} className="border-bottom">
                            <td className="paymentauth">
                              <span className="visually-hidden"> row {index + 2} column 1 {billingContent?.billing_payment_auth_holder_name_text}: </span>
                              {item?.accountHolderName}
                            </td>
                            <td className="paymentauth">
                              <span className="visually-hidden"> column 2 {billingContent?.billing_payment_auth_scheduled_on_text}: </span>
                              {item?.addedDate}
                            </td>
                            <td className="paymentauth">
                              <span className="visually-hidden"> column 3 {billingContent?.billing_payment_auth_scheduled_for_text}: </span>
                              {item?.requestedPaymentDate}
                            </td>
                            <td className="paymentauth">
                              <span className="visually-hidden"> column 4 {billingContent?.billing_payment_auth_account_type_text}: </span>
                              {item?.paymentMethod === "CC"
                                ? getPaymentMethod(item?.cardType) : ((Cookies.get('owningCarrier') === 'Q5' && item?.paymentMethod === 'EFT') ? billingContent?.billing_autopay_eft_txt : item.paymentMethod)}
                            </td>
                            <td className="paymentauth">
                              <span className="visually-hidden"> column 5 {billingContent?.billing_payment_auth_account_last_four_text}: </span>
                              {item?.accountLast4}
                            </td>
                            <td className="paymentauth">
                              <span className="visually-hidden"> column 6 {billingContent?.billing_payment_auth_amount_text}: </span>
                              {item?.authorizedAmount}
                            </td>
                            <td className="paymentauth">
                              <span className="visually-hidden"> column 7 {billingContent?.billing_payment_auth_payment_freq_text}: </span>
                              {item?.howBilledCode}
                            </td>
                            <td className="paymentauth">
                              <span className="visually-hidden"> column 8 {billingContent?.billing_payment_auth_routing_no_text}: </span>
                              {item?.routingNumber ? item.routingNumber : "NA"}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </Modal.Body>
        </main>
        </>
    );
};

export default Paymentauth;